export default function Profile(){
    return <p> I know the profile doesnt work, coming soon</p>
}
